<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="breadCrumbItems" hasBreadcrumb />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <McButtonBack />
      </div>
    </div>

    <div class="card mc-setting-api">
      <div class="card-body">
        <div class="w-50 mc-setting-api-wrapper">
          <div class="w-75">
            <b-form-group class="mb-3">
              <template #label>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="mb-0">API</label>
                  <span v-b-tooltip.topleft :title="$t('setting.list.development.tooltipExpired')">
                    <i class="mc-fa icon-outline_info"></i>
                  </span>
                </div>
              </template>
              <div class="form-password">
                <b-form-input
                  v-if="showAPI"
                  readonly
                  v-model="publicApiKey"
                  type="text"
                  placeholder="API"
                  class="mc-disabled"
                ></b-form-input>
                <b-form-input
                  v-else
                  readonly
                  v-model="publicApiKey"
                  type="password"
                  placeholder="API"
                  class="mc-disabled"
                ></b-form-input>
                <i
                  @click="toggleAPI"
                  class="mc-fa-password"
                  :class="{
                    'icon-outline_eye': showAPI,
                    'icon-outline_eye-off-2': !showAPI,
                  }"
                ></i>
              </div>
              <div class="mc-setting-api__button">
                <b-button variant="primary" @click.prevent="copyCode">
                  <i class="mc-fa icon-outline_copy"></i>
                </b-button>
                <b-button
                  v-show="!this.publicApiKey"
                  variant="primary"
                  class="ms-2"
                  @click.prevent="generateAPIKey"
                >
                  {{ $t('setting.list.development.publishAPI') }}
                </b-button>
              </div>
            </b-form-group>
            <b-form-group class="mb-4" v-if="this.publicApiKey">
              <template #label>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="mb-0"> {{ $t('setting.list.development.tokenExpired') }}</label>
                  <span v-b-tooltip.topleft :title="$t('setting.list.development.tooltipExpired')">
                    <i class="mc-fa icon-outline_info"></i>
                  </span>
                </div>
              </template>
              <multiselect
                :options="[$t('global.time.oneDay'), $t('global.time.oneWeek')]"
                v-model="tokenExpiry"
                :placeholder="$t('setting.list.development.selectPeriode')"
              >
              </multiselect>
            </b-form-group>
            <b-button
              variant="primary"
              v-if="this.publicApiKey"
              @click.prevent="updateExpiryAPIKey"
            >
              {{ $t('global.action.apply') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
import Multiselect from 'vue-multiselect'
import McButtonBack from '@/components/McButtonBack'
import {
  GENERATE_PUBLIC_API_KEY,
  GET_COMPANY_INPUT,
  UPDATE_COMPANY,
} from '@/services/api/setting/development'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    McButtonBack,
  },
  mixins: [Helper],
  apollo: {
    company: {
      query: GET_COMPANY_INPUT,
      variables() {
        return {
          filter: {
            id: Helper.methods.getCompanyId(),
            name: Helper.methods.getCompanyName(),
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.publicApiKey = data.company.company.publicApiKey
          const expired = data.company.company.publicApiTokenExpiry

          this.tokenExpiry =
            expired === 'null' || expired === 1440
              ? this.$t('global.time.oneDay')
              : this.$t('global.time.oneWeek')
          this.company = data.company.company
        }
      },
    },
  },
  data() {
    return {
      showAPI: false,
      periode: null,
      periodeForm: false,
      company: {},
      publicApiKey: '',
      tokenExpiry: '',
    }
  },

  computed: {
    title() {
      return this.$t('setting.list.development.oldTitle')
    },
    breadCrumbItems() {
      return [
        {
          text: this.$t('setting.list.development.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.homePage.tokenApi'),
          to: '/setting/token-api',
        },
        {
          text: this.$t('setting.list.development.oldTitle'),
        },
      ]
    },
  },

  methods: {
    toggleAPI() {
      this.showAPI = !this.showAPI
    },

    copyCode() {
      navigator.clipboard.writeText(this.publicApiKey)
      this.$mcToast.success(this.$t('setting.list.development.copyApiCode'))
    },

    generateAPIKey() {
      this.periodeForm = true

      this.$apollo
        .mutate({
          mutation: GENERATE_PUBLIC_API_KEY,
        })
        .then((response) => {
          this.publicApiKey = response.data.generatePublicApiKey.publicApiKey.publicApiKey
        })
        .catch((err) => console.log(err))
    },

    updateExpiryAPIKey() {
      const expiryMinute =
        this.tokenExpiry === this.$t('global.time.oneDay') ? 24 * 60 : 7 * 24 * 60

      this.$apollo
        .mutate({
          mutation: UPDATE_COMPANY,
          variables: {
            input: {
              id: this.company.id,
              publicApiTokenExpiry: expiryMinute,
            },
          },
        })
        .then(() => {
          this.$mcToast.success(this.$t('setting.list.development.tokenPeriodAlert'))
        })
        .catch((err) => console.log(err))
    },
  },
}
</script>
